<template>
  <action-dispatcher action="product/get" :parameters="{}" class="view-home">
    <div v-if="!products.length" class="centralize-row text-center pt-9">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <img
            class="d-block mb-9 mx-auto"
            src="../assets/images/home/welcome.svg"
          />
          <h5>Bem-vindo(a) {{ userInfo.name }}</h5>
          <div class="text-secondary mb-9">
            Comece cadastrando o seu primeiro produto:
          </div>

          <big-buttons
            class="pb-6"
            :options="[
              {
                id: 'online-course',
                name: 'Curso online',
                src: require(`@/assets/images/new-product/curso-online.svg`)
              },
              {
                id: 'signature',
                name: 'Assinatura',
                src: require(`@/assets/images/new-product/assinatura.svg`)
              },
              {
                id: 'event',
                name: 'Evento presencial',
                src: require(`@/assets/images/new-product/ticket.svg`)
              }
            ]"
            @input="open"
          />
        </div>
      </div>
    </div>

    <template v-else>
      <div class="d-lg-flex align-items-center mb-6">
        <div class="flex-fill">
          <h4
            class="fs-14 text-semibold text-dark d-lg-inline mr-2 greeting-container"
          >
            <span v-if="isChristmasSeason" class="christmas-hat-wrapper">
              <span class="christmas-hat">🎅</span>{{ greeting }},
              {{ userInfo.name }}
            </span>
            <template v-else>{{ greeting }}, {{ userInfo.name }}</template>
          </h4>
          <span class="text-dark-40 fs-12">
            Seu último acesso foi {{ lastAccess }}
          </span>
        </div>
        <snow-button
          size="sm"
          variant="borderless"
          :text="hideValues ? 'Mostrar valores' : 'Ocultar valores'"
          :icon="hideValues ? 'ph ph-eye' : 'ph ph-eye-slash'"
          @click="hideValues = !hideValues"
        />
      </div>

      <div
        class="mb-6 rounded-16 bg-2 p-6 d-lg-flex justify-content-between"
        v-if="showCheckIn"
      >
        <div>
          <h4
            class="mb-3 text-semibold text-dark fs-18 d-flex align-items-center gap-3"
          >
            <i class="ph ph-qr-code fs-28" />
            Check-in participantes
          </h4>
          <div class="fs-14 text-dark-40">
            Faça seu check-in dos participantes através da leitura do QR Code
          </div>
        </div>

        <snow-button
          text="Fazer check-in"
          class="d-none d-lg-flex"
          right-icon="ph-bold ph-caret-down text-light-40"
          @click="modalCheckin = true"
        />
        <snow-button
          class="d-lg-none w-100 mt-3"
          text="Fazer check-in"
          right-icon="ph-bold ph-caret-down text-light-40"
          @click="modalCheckin = true"
        />
      </div>

      <div v-if="$permissions.hasPermission('visualizar-valores')" class="row">
        <div class="col-lg-6 mb-6">
          <overview-card
            title="Minha conta"
            :hideValues="hideValues"
            :options="[
              {
                name: 'Ganhos (últimos 7 dias)',
                value: `R$ ${formatMoney(this.weekRevenue)}`,
                class: 'text-dark',
                blur: true
              },
              {
                name: 'Saldo disponível',
                value:
                  balance && balance.length
                    ? `${formatCurrencySymbol(
                        balance[0].currency
                      )} ${formatMoney(balance[0].amount)}`
                    : '-',
                // secondaryValue: '-',
                class: 'text-dark',
                blur: true
              },
              {
                name: 'A liberar',
                value:
                  balance && balance.length && balance[0].future
                    ? `${formatCurrencySymbol(
                        balance[0].currency
                      )} ${formatMoney(
                        balance[0].future.total - balance[0].amount
                      )}`
                    : '-',
                class: 'text-dark',
                blur: true
              }
            ]"
          />
        </div>

        <div class="col-lg-6">
          <div
            v-if="
              products.length &&
                products.filter(p => p.status === 'draft').length
            "
            class="mb-6"
          >
            <div class="rounded-24 bg-2 p-6">
              <div class="d-flex align-items-center mb-4">
                <span class="text-semibold text-dark fs-14">
                  Produtos que precisam de atenção
                </span>
                <snow-button
                  size="sm"
                  text="Ver mais"
                  variant="borderless"
                  class="ml-auto text-dark-40 d-none d-md-flex"
                  :to="{ name: 'product' }"
                />
              </div>
              <div class="product-list-carousel pb-2">
                <draft-product
                  v-for="(product, index) in products
                    .filter(p => p.status === 'draft')
                    .slice(0, 6)"
                  :key="`draft-product-${index}`"
                  :product="product"
                />
              </div>
              <snow-button
                text="Ver mais"
                variant="outline"
                class="d-md-none w-100 my-3 text-dark-40"
                :to="{ name: 'product' }"
              />
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="rounded-24 bg-2 p-6 mb-6">
            <sale-chart
              @change-product="onChangeProduct"
              @change-dates="onChangeDates"
            />
          </div>

          <div class="row">
            <div
              v-for="(item, index) in cardInfos"
              :key="index"
              :class="`col-lg-${12 / cardInfos.length} py-3 py-lg-0`"
            >
              <overview-card
                :title="item.title"
                :options="item.options"
                :externalLoading="salesLoading"
                :hideValues="hideValues"
              />
            </div>
          </div>
        </div>
      </div>
      <responsive-modal v-model="modalCheckin">
        <event-checkin-modal
          @success="onCheckinSuccess"
          @repeated-code="onRepeatedCode"
          @close="modalCheckin = false"
        />
      </responsive-modal>
      <bp-dialog
        v-model="dialog.value"
        v-bind="dialogOptions"
        @action="onDialogAction"
      />
    </template>
  </action-dispatcher>
</template>

<script>
import SaleChart from "@/components/home/SaleChart.vue";
import DraftProduct from "@/components/home/DraftProduct.vue";
import OverviewCard from "@/components/home/card/Overview.vue";
import EventCheckinModal from "../components/events/EventCheckinModal.vue";

import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";

import { formatMoney, getCurrencySymbol } from "@/functions/helpers";

export default {
  components: {
    SaleChart,
    DraftProduct,
    OverviewCard,
    EventCheckinModal
  },
  data() {
    const date = new Date();
    date.setHours(12, 0, 0, 0);
    const paid_at__lte = date.toISOString().slice(0, 10);
    date.setDate(date.getDate() - 6);
    const paid_at__gte = date.toISOString().slice(0, 10);

    return {
      hideValues: true,
      dates: {
        paid_at__gte,
        paid_at__lte
      },
      weekRevenue: 0,
      totalRevenue: 0,
      saleCount: 0,
      reversalCount: 0,
      paidBillet: 0,
      product_id: "",
      salesLoading: false,
      modalCheckin: false,
      dialog: {
        variant: "positive",
        value: false
      }
    };
  },
  computed: {
    ...mapState("sale", ["sales"]),
    ...mapState("product", ["products"]),
    ...mapState("financial", ["balance"]),
    showCheckIn() {
      return (
        this.$permissions.hasPermission("gerenciar-participantes") &&
        this.products.length &&
        this.products.filter(
          p => p.type_product === "onsite_event" && p.status === "active"
        ).length
      );
    },
    greeting() {
      const hour = new Date().getHours();
      if (hour < 12 && hour >= 4) return "Bom dia";
      if (hour < 18) return "Boa tarde";
      return "Boa noite";
    },
    isChristmasSeason() {
      const month = new Date().getMonth();
      return month === 11; // Dezembro
    },
    lastAccess() {
      return moment(this.userInfo.last_access).fromNow();
    },
    _dates() {
      const date = new Date(this.dates.paid_at__lte);
      date.setDate(date.getDate() + 1);
      const paid_at__lte = date.toISOString().slice(0, 10);
      return {
        ...this.dates,
        paid_at__lte
      };
    },
    userInfo() {
      if (!this.$user.user)
        return {
          name: "",
          last_access: ""
        };

      return this.$user.user;
    },
    reversalPercentage() {
      return this.reversalCount
        ? this.saleCount
          ? ((this.reversalCount / this.saleCount) * 100).toFixed(2)
          : 100
        : 0;
    },
    cardInfos() {
      return [
        {
          title: "Performance",
          options: [
            {
              name: "Vendas",
              value: this.saleCount,
              class: "text-dark",
              blur: true
            }
          ]
        },
        {
          title: "Receitas",
          options: [
            {
              name: "Total",
              value: `R$ ${formatMoney(this.totalRevenue)}`,
              class: "text-dark",
              blur: true
            },
            {
              name: "Reembolsos",
              value: this.reversalCount,
              class: "text-dark",
              blur: true
            },
            {
              name: "Reembolso (%)",
              value: `${this.reversalPercentage}%`,
              class: "text-dark",
              blur: true
            }
          ]
        },
        {
          title: "Boletos",
          options: [
            {
              name: "Pagos",
              value: this.paidBillet,
              class: "text-dark",
              blur: true
            }
          ]
        }
      ];
    },
    dialogOptions() {
      const variant = this.dialog.variant;
      return {
        variant,
        text:
          variant == "positive"
            ? "Check-in realizado com sucesso!"
            : "Esse código já foi utilizado.",
        buttonText: this.dialog.is_manual
          ? "Ok, entendi"
          : "Fazer novo check-in",
        icon:
          variant == "positive"
            ? "fa fa-circle-check"
            : "fa fa-circle-exclamation"
      };
    }
  },
  methods: {
    open(type_product) {
      this.$router.push({ name: `product-new-${type_product}` });
    },
    async dispatch() {
      try {
        this.salesLoading = true;
        let params = {
          ...this._dates,
          product_id: this.product_id,
          status:
            "reversal,reversal_manual,reversal_manual_admin,webhook_reversal,chargeback",
          limit: 100000
        };
        this.$store
          .dispatch("sale/getCount", params)
          .then(r => (this.reversalCount = r));

        await this.$store
          .dispatch("reports/get", {
            start: params.paid_at__gte,
            end: moment().format("YYYY-MM-DD")
          })
          .then(r => {
            this.saleCount = r.reduce((prev, cur) => prev + cur.qty, 0);
          });

        params.status = "paid,completed";
        params.payment_process = "billet";
        this.$store
          .dispatch("sale/getCount", params)
          .then(r => (this.paidBillet = r));

        let totalParams = {
          product_id: this.product_id,
          status__in: ["paid", "completed"],
          ...this._dates
        };
        await this.$store
          .dispatch("sale/getTotal", totalParams)
          .then(r => (this.totalRevenue = r));
      } finally {
        this.salesLoading = false;
      }
    },
    onChangeProduct(product_id) {
      this.product_id = product_id;
      this.dispatch();
    },
    onChangeDates(period) {
      const dates = [
        moment()
          .subtract(period - 1 || 1, "days")
          .format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      ];
      this.dates = {
        paid_at__gte: dates[0],
        paid_at__lte: dates[1]
      };
      this.dispatch();
    },
    formatCurrencySymbol(val) {
      return getCurrencySymbol(val);
    },
    formatMoney(val) {
      return formatMoney(val);
    },
    onCheckinSuccess() {
      this.modalCheckin = false;
      this.dialog.variant = "positive";
      this.dialog.value = true;
    },
    onRepeatedCode() {
      this.modalCheckin = false;
      this.dialog.variant = "alert";
      this.dialog.value = true;
    },
    onDialogAction() {
      this.modalCheckin = true;
    }
  },
  mounted() {
    this.$store.commit("sale/setFilterDates", Object.values(this.dates));

    const filters = {
      status__in: ["paid", "completed"],
      paid_at__gte: moment()
        .subtract(6, "days")
        .format("YYYY-MM-DD"),
      paid_at__lte: moment().format("YYYY-MM-DD")
    };
    this.$store
      .dispatch("sale/getTotal", filters)
      .then(r => (this.weekRevenue = r));

    this.$store.dispatch("financial/getBalance");
    this.dispatch();
  }
};
</script>

<style lang="scss" scoped>
.view-home {
  position: relative;

  .greeting-container {
    .christmas-hat-wrapper {
      position: relative;
      display: inline-block;
    }

    .christmas-hat {
      position: absolute;
      top: -18px;
      left: -5px;
      font-size: 20px;
      pointer-events: none;
      animation: bounce 1s ease-in-out infinite;
    }
  }

  @keyframes bounce {
    0%,
    100% {
      transform: translateY(0) rotate(-10deg);
    }
    50% {
      transform: translateY(-3px) rotate(-10deg);
    }
  }

  .product-list-carousel {
    display: flex;
    overflow-x: scroll;
    gap: 12px;

    &::-webkit-scrollbar {
      border-radius: 0 4px 4px 0;
      height: 5.3px;

      @media screen and (max-width: 991px) {
        height: 0;
      }
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(219, 221, 230, 0.85);
      border-radius: 10px;
    }
  }
}
</style>
